import React, { Component } from 'react';
import { Grid, GridCell } from 'rmwc/Grid';
import { connect } from 'react-redux';
import {Button} from 'rmwc/Button';
import { Snackbar } from 'rmwc/Snackbar';
import { Typography } from 'rmwc/Typography';
import { Select } from 'rmwc/Select';
import { Link } from 'react-router-dom'
import { Card } from 'rmwc/Card';
import { TextField} from 'rmwc/TextField';
import * as api from '../../api/api';
import StatusMessage from '../../util/StatusMessage'
import {default as Reactsel} from 'react-select';
import {stateToHTML} from 'draft-js-export-html';
import { EditorState, ContentState, convertFromHTML } from 'draft-js';
import { Editor } from 'react-draft-wysiwyg';
import 'react-draft-wysiwyg/dist/react-draft-wysiwyg.css';

class TaxonomyConfiguration extends Component {
	constructor(props) {
		super(props)
    	this.state = {
            childPresent: false,
            formOpen: false,
            specificFormOpen: false,
            specificFetchForm: false,
            editForm: false,
            specificEditForm: false,
    		data: {
    			sectionType: '',
                sectionName: '',
                taxonomyComboDropDown: [],
                productComboDropDown: [],
                topicComboDropDown: [],
                aspectComboDropDown: []
    		},
            dispData: {
                renderSectionDetails: []
            },
            addData: {
                nameOfSection: '',
                tagOfSection: '',
                imgLinkSection: '',
                listingSequenceSection: '',
                active: 1,

            },
            editorData: {
                htmlText: '',
                editorState: EditorState.createEmpty(),
                contentValue:'',
                contentState:'',
                editorStateRead:EditorState.createEmpty(),
            },
            fetchData: {
                taxonomyDropDown: [],
                parentId: '',
                aspectDropDown: [],
                aspectId: ''
            },
            addedTaxonomyParent: [],
            addedProductParent: [],
            addedTopicParent: [],
            addedAspectParent: [],
            errorMessage: '',
            fetchErrorMessage: ''
    	}
    }

    handleBackAction = (e) => {
        e.preventDefault()
        this.props.history.push(`/portal/app/admin/learning_taxonomies`)
    }

    handleActiveChange = evt => {
        let data = Object.assign({}, this.state.addData)
        data.active = evt.target.value
        this.setState({addData: data})
  };
  

    handleNameChange = (event) => {
        let data = Object.assign({}, this.state.addData)
        data.nameOfSection = event.target.value
        this.setState({addData: data}) 
    }

    handleTagChange = (event) => {
        let data = Object.assign({}, this.state.addData)
        data.tagOfSection = event.target.value
        this.setState({addData: data}) 
    }

    handleListingSequenceChange = (event) => {
        let addData = Object.assign({}, this.state.addData)
        addData.listingSequenceSection = event.target.value
        this.setState({addData: addData}) 
    }

    handleEditorDescriptionUpdate: Function = (editorState) => {
        let editorData = Object.assign({}, this.state.editorData)
        editorData.editorStateRead = editorState
        this.setState({editorData: editorData});
    }

    handleImageLinkChange = (event) => {
        let addData = Object.assign({}, this.state.addData)
        addData.imgLinkSection = event.target.value
        this.setState({addData: addData}) 
    }

    handleFetchParentChange = (event) => {
        let fetchData = Object.assign({}, this.state.fetchData)
        fetchData.parentId = event.target.value
        this.setState({fetchData: fetchData})
    }

    handleThemeAspectParentChange = (event) => {
        let fetchData = Object.assign({}, this.state.fetchData)
        fetchData.aspectId = event.target.value
        this.setState({fetchData: fetchData})
    }

    handleFormOpen = (e) => {
        e.preventDefault()
        let data = Object.assign({}, this.state.data)

        if (this.state.data.sectionType !== '1') {
            let newSectionType = parseInt(this.state.data.sectionType) - 1
            let url = `admin/taxonomy_details/${newSectionType}`
            let aspectSection = parseInt(this.state.data.sectionType) - 2
            let fetchAspects = `admin/taxonomy_details/${aspectSection}`
            api.getResponse(this.props.user.accessToken, url)
            .then((result) => {
                if (result.status === 'success') {
                    data.taxonomyComboDropDown = result.data
                    if (parseInt(this.state.data.sectionType) === 5){
                        api.getResponse(this.props.user.accessToken, fetchAspects)
                        .then((result) => {
                            if (result.status === 'success') {
                                data.aspectComboDropDown = result.data
                                this.setState({data: data, specificFormOpen: true})
                            }
                        })
                    }
                    else {
                        this.setState({data: data, specificFormOpen: true})
                    }
                    
                }
            })
        }
        this.setState({formOpen: true, errorMessage: ''})
    }

    handleChildFetch = (e) => {
        if (this.state.fetchData.parentId === '') {
            return this.setState({fetchErrorMessage: 'Please select a Taxonomy Parent to render the Childs.', formOpen: false})
        }
        e.preventDefault()
        let dispData = Object.assign({}, this.state.dispData)
        let fetchData = Object.assign({}, this.state.fetchData)
        let url = `admin/taxonomy_child_details/${this.state.fetchData.parentId}/${this.state.data.sectionType}`
        api.getResponse(this.props.user.accessToken, url)
        .then((result) => {
            if (result.status == 'success') {
                dispData.renderSectionDetails = result.data
                fetchData.aspectId = ''
                this.setState({dispData: dispData, childPresent: true, formOpen: false, fetchErrorMessage: '', errorMessage: '', fetchData: fetchData})
            }
            else if (result.status === 'error'){
                fetchData.aspectId = ''
                this.setState({fetchData: fetchData, childPresent: false, fetchErrorMessage: '', errorMessage: ''})
            }
        })        
    }

    fetchAspectThemeChild = (e) => {
        e.preventDefault()
        if (this.state.fetchData.aspectId === '') {
            return this.setState({fetchErrorMessage: 'Please select an Aspect to render the Child Themes.', formOpen: false})
        }
        let dispData = Object.assign({}, this.state.dispData)
        let fetchData = Object.assign({}, this.state.fetchData)
        let url = `admin/taxonomy_child_details/${this.state.fetchData.aspectId}/${this.state.data.sectionType}`
        api.getResponse(this.props.user.accessToken, url)
        .then((result) => {
            if (result.status == 'success') {
                dispData.renderSectionDetails = result.data
                fetchData.parentId = ''
                this.setState({dispData: dispData, childPresent: true, formOpen: false, fetchErrorMessage: '', errorMessage: '', fetchData: fetchData})
            }
            else if (result.status === 'error'){
                fetchData.parentId = ''
                this.setState({fetchData: fetchData, childPresent: false, fetchErrorMessage: '', errorMessage: ''})
            }
        })
    }

    handleTaxonomyParentChange = (option) => {
        this.setState(state => {
            return {
               addedTaxonomyParent : option
            };
        });
    }

    handleProductParentChange = (option) => {
        this.setState(state => {
            return {
               addedProductParent : option
            };
        });
    }

    handleAspectParentChange = (option) => {
        this.setState(state => {
            return {
               addedAspectParent : option
            };
        });
    }

    handleTopicParentChange = (option) => {
        this.setState(state => {
            return {
               addedTopicParent : option
            };
        });
    }

    handleSaveTaxonomy = (e) => {
        e.preventDefault()
        let htmlText = stateToHTML(this.state.editorData.editorStateRead.getCurrentContent())
        if (parseInt(this.props.match.params.type) === 1) {
            if (this.state.addData.nameOfSection === '') {
                return this.setState({errorMessage: 'Please enter the name of the Taxonomy to save the taxonomy'})
            }
        }
        else if ((parseInt(this.props.match.params.type) > 1) && (parseInt(this.props.match.params.type) < 5)){
            if ((this.state.addData.nameOfSection === '') || (this.state.addData.tagOfSection === '') || (this.state.addData.imgLinkSection === '') || (this.state.addData.listingSequenceSection === '')){
                return this.setState({errorMessage: 'Please check if all the fields are filled'})
            }

            if (this.state.addedTaxonomyParent.length === 0){
                return this.setState({errorMessage: 'Please select atleast one Parent before updating the resource.'})
            }            
            if (htmlText.length < 15){
                return this.setState({errorMessage: 'Description is Mandatory and should have minimum of 15 characters'})
            }         
        }

        let addData = Object.assign({}, this.state.addData)
        let dispData = Object.assign({}, this.state.dispData)

        var myStringArray = this.state.addedProductParent;
        var arrayLength = myStringArray.length;
        let selectedProductString = []
        for (var i = 0; i < arrayLength; i++) {
            selectedProductString.push(parseInt(myStringArray[i].value))
        }

        var myStringTopicArray = this.state.addedTopicParent;
        var arrayLength = myStringTopicArray.length;
        let selectedTopicString = []
        for (var i = 0; i < arrayLength; i++) {
            selectedTopicString.push(parseInt(myStringTopicArray[i].value))
        }
        
        let len = this.state.addedAspectParent.length
        for (var i = 0; i < len; i++) {
            this.state.addedTaxonomyParent.push(this.state.addedAspectParent[i])
        }

        let values = {
            'name' : this.state.addData.nameOfSection,
            'tag' : this.state.addData.tagOfSection,
            'img_link' : this.state.addData.imgLinkSection,
            'listing_sequence' : this.state.addData.listingSequenceSection,
            'description': htmlText,
            'active': parseInt(this.state.addData.active),
            'learning_taxonomy_type_id' : this.state.data.sectionType,
            'associated_taxonomies' : this.state.addedTaxonomyParent,
            'data_detail':{
                'certification_type_id': selectedProductString,
                'mc_topic_id': selectedTopicString
            }
        }

        let url2 = `learning_taxonomy/${this.props.match.params.type}`

        api.adminAddLearningTaxonomy(this.props.user.accessToken, values)
        .then((result) => {
            if(result.status === 'invalid_description'){
                this.setState({errorMessage: 'Description is too long'})
            }
            else if(result.status === 'error'){
                this.setState({errorMessage: result.message})
            }
            else{
                this.handleFormClose()
                if (this.state.data.sectionType === '1') {
                    api.getResponse(this.props.user.accessToken, url2)
                    .then((result) => {
                        dispData.renderSectionDetails = result
                        this.setState({dispData: dispData, childPresent: true})
                    })
                }
            }
        })
    }

    handleFormClose = (e) => {
        let addData = Object.assign({}, this.state.addData)
        let editorData = Object.assign({}, this.state.editorData)
        addData.nameOfSection = '',
        addData.tagOfSection = '',
        addData.parentSectionId = '',
        addData.listingSequenceSection = '',
        addData.imgLinkSection = '',
        editorData.editorStateRead =  ''
        this.setState({formOpen: false, specificFormOpen: false, editorData: editorData, addData: addData, addedTaxonomyParent: [], addedProductParent: [], addedTopicParent: [], errorMessage: ''})
    }

    handleEdit = (e, taxonomyId) => {
       e.preventDefault()

       this.props.history.push(`/portal/app/admin/learning_taxonomies/${this.state.data.sectionType}/${this.state.data.sectionName}/edit/${taxonomyId}`)
    }

    fetchStandaloneThemes = (e) => {
        e.preventDefault()

        let dispData = Object.assign({}, this.state.dispData)
        let fetchData = Object.assign({}, this.state.fetchData)
        let fetchStandalone = `admin/learning_taxonomy/standalone_information/taxonomy/${this.state.data.sectionType}`

        api.getResponse(this.props.user.accessToken, fetchStandalone)
        .then((result) => {
            if (result.status === 'success'){
                dispData.renderSectionDetails = result.data
                fetchData.aspectId = ''
                fetchData.parentId = ''
                this.setState({dispData: dispData, childPresent: true, formOpen: false, fetchErrorMessage: '', errorMessage: '', fetchData: fetchData})
            }
            else {
                fetchData.aspectId = ''
                fetchData.parentId = ''
                this.setState({fetchData: fetchData, childPresent: false, fetchErrorMessage: '', errorMessage: ''})
            }
        })
    }

    clearStandaloneThemes= (e) => {
        e.preventDefault()

        this.setState({childPresent: false, fetchErrorMessage: '', errorMessage: ''})
    }

    componentDidMount() {
    	let data = Object.assign({}, this.state.data)
        let fetchData = Object.assign({}, this.state.fetchData)
        let dispData = Object.assign({}, this.state.dispData)

    	data.sectionType = this.props.match.params.type
        data.sectionName = this.props.match.params.typeName
    	this.setState({data: data})

        let newSectionType = parseInt(this.props.match.params.type) - 1
        let url = `learning_taxonomy/${newSectionType}`
        let url2 = 'admin/learning_taxonomy/product/information'
        let url3 = `learning_taxonomy/${this.props.match.params.type}`

        if (this.props.match.params.type !== '1') {
            return api.getResponse(this.props.user.accessToken, url)
            .then((result) => {
                fetchData.taxonomyDropDown = result
                this.setState({fetchData: fetchData, specificFetchForm: true})
                api.getResponse(this.props.user.accessToken, url2)
                .then((result) => {
                    if (result.status === 'success') {
                        data.productComboDropDown = result.data.certifications
                        data.topicComboDropDown = result.data.topics
                        if (this.props.match.params.type === '5'){
                            let newSectionType = parseInt(this.props.match.params.type) - 2
                            let fetchAspectList = `learning_taxonomy/${newSectionType}`
                            return api.getResponse(this.props.user.accessToken, fetchAspectList)
                            .then((result) => {
                                fetchData.aspectDropDown = result
                                this.setState({fetchData: fetchData, data: data})
                            })
                        }
                        else {
                            this.setState({data: data})
                        }
                    }
                })
            })
        }
        else {
            return api.getResponse(this.props.user.accessToken, url3)
            .then((result) => {
                dispData.renderSectionDetails = result
                this.setState({dispData: dispData, childPresent: true})
            })
        }
    }

    render(){
        let handleFormOpen = this.handleFormOpen
        let handleFormClose = this.handleFormClose
        let handleBackAction = this.handleBackAction
        let handleSaveTaxonomy = this.handleSaveTaxonomy
        let handleChildFetch = this.handleChildFetch
        let handleEdit = this.handleEdit
        let fetchAspectThemeChild = this.fetchAspectThemeChild
        let fetchStandaloneThemes = this.fetchStandaloneThemes
        let clearStandaloneThemes = this.clearStandaloneThemes
        let themeAddForm
        let generalAddForm
        let specificAddForm
        let fetchForm
        let individualTaxonomy, themeFetchForm, aspectAddForm
        let activeComponent = (
        <GridCell span = "12">
          <Select
            onChange={this.handleActiveChange} 
            value={this.state.data.active}
          >
            <option value = "1">Active</option>
            <option value = "0">Inactive</option>
          </Select>
        </GridCell>
        )
        if (this.props.match.params.type === '3'){
            aspectAddForm = (
                <div style={{padding: '0px'}}>
                    <GridCell span = "12">
                        <Reactsel
                                name="productlist"
                                onChange={this.handleProductParentChange}
                                value={this.state.addedProductParent}
                                options={this.state.data.productComboDropDown}
                                placeholder="--Select Product Parent--"
                                isMulti>
                        </Reactsel>
                    </GridCell>
                    <br />
                    <GridCell span = "12">
                        <Reactsel
                                name="topiclist"
                                onChange={this.handleTopicParentChange}
                                value={this.state.addedTopicParent}
                                options={this.state.data.topicComboDropDown}
                                placeholder="--Select MC Parent--"
                                isMulti>
                        </Reactsel>
                    </GridCell>
                </div>
            )
        }

        if (this.props.match.params.type === '5'){
            themeAddForm = (
                <div style={{padding: '0px'}}>
                    <GridCell span = "12">
                        <Reactsel
                                name="productlist"
                                onChange={this.handleProductParentChange}
                                value={this.state.addedProductParent}
                                options={this.state.data.productComboDropDown}
                                placeholder="--Select Product Parent--"
                                isMulti>
                        </Reactsel>
                    </GridCell>
                    <br />
                    <GridCell span = "12">
                        <Reactsel
                                name="topiclist"
                                onChange={this.handleTopicParentChange}
                                value={this.state.addedTopicParent}
                                options={this.state.data.topicComboDropDown}
                                placeholder="--Select MC Parent--"
                                isMulti>
                        </Reactsel>
                    </GridCell>
                    <br />
                    <GridCell span = "12">
                        <Reactsel
                                name="aspectlist"
                                onChange={this.handleAspectParentChange}
                                value={this.state.addedAspectParent}
                                options={this.state.data.aspectComboDropDown}
                                placeholder="--Select Aspect--"
                                isMulti>
                        </Reactsel>
                    </GridCell>
                </div>
            )

            themeFetchForm = (
                <Grid>
                    <GridCell span = "5">
                        <Select
                            name="aspectSection"
                            onChange={this.handleThemeAspectParentChange}
                            value={this.state.fetchData.aspectId}
                            className="select-component"
                            placeholder="--Select an Aspect--">
                            {this.state.fetchData.aspectDropDown.map(list => (
                                <option key={list.id} value={list.id} data-name={list.name}>
                                    {list.name}
                                </option>
                            ))}
                        </Select>
                    </GridCell>
                    <GridCell span = "2">
                        <Button raised style={{ width: '100%' }} onClick={((e) => fetchAspectThemeChild(e))}>Fetch</Button>
                    </GridCell>
                    <GridCell span = "5">
                    </GridCell>
                    <GridCell span = "12">
                    </GridCell>
                    <GridCell span = "3">
                        <Button dense style={{ width: '100%' }} onClick={((e) => fetchStandaloneThemes(e))}>Fetch Standalone Themes</Button>
                    </GridCell>
                    <GridCell span = "3">
                        <Button dense style={{ width: '100%' }} onClick={((e) => clearStandaloneThemes(e))}>Clear Standalone Themes</Button>
                    </GridCell>
                </Grid>
            )
        }

        //if (this.state.dispData.renderSectionDetails.length > 0)  {
        if ((this.state.childPresent === true) && (this.state.dispData.renderSectionDetails.length > 0)) {
            individualTaxonomy = (
                <Grid>
                    {this.state.dispData.renderSectionDetails.map(function(taxonomy){
                        let taxonomyId = taxonomy.id
                        let taxonomyName = taxonomy.name
                        let uniqueKey = taxonomyId + taxonomyName
                        return (
                            <GridCell span = "6" key = {uniqueKey}>
                                <Card style={{padding: '7px'}}>
                                    <Grid className="opportunity-list-item">
                                        <GridCell span = "10">
                                            <Typography align="left">{taxonomy.name}</Typography>
                                        </GridCell>
                                        <GridCell span = "2">
                                            <Button style={{ width: '100%' }} onClick={((e) => handleEdit(e, taxonomyId))}>Edit</Button>
                                        </GridCell>
                                    </Grid>
                                </Card>
                            </GridCell>
                        )
                    })}
                </Grid>
            )
        }
        else if (this.state.childPresent === false) {
            individualTaxonomy = (
                <Grid className="opportunity-list-item">
                    <GridCell span = "6">
                        <Card style={{padding: '7px'}}>
                            <Grid className="opportunity-list-item">
                                <GridCell span = "12">
                                    <Typography> There are currently no taxonomies to this parent.</Typography>
                                </GridCell>
                            </Grid>
                        </Card>
                    </GridCell>
                </Grid>
            )
        }

        if (this.state.specificFetchForm === true) {
            fetchForm = (
                <Grid style={{padding: '0px'}}>
                    <GridCell span = "10">
                        <Select
                            name="parentSection"
                            onChange={this.handleFetchParentChange}
                            value={this.state.fetchData.parentId}
                            className="select-component"
                            placeholder="--Select a Taxonomy Parent--">
                            {this.state.fetchData.taxonomyDropDown.map(list => (
                                <option key={list.id} value={list.id} data-name={list.name}>
                                    {list.name}
                                </option>
                            ))}
                        </Select>
                    </GridCell>
                    <GridCell span = "2">
                        <Button raised style={{ width: '100%' }} onClick={((e) => handleChildFetch(e))}>Fetch</Button>
                    </GridCell>
                    <GridCell span = "5">
                    </GridCell>
                    <GridCell span = "12">
                        {themeFetchForm}
                    </GridCell>
                    <GridCell span = "12">
                        <StatusMessage error_msg = {this.state.fetchErrorMessage} />
                    </GridCell>
                </Grid>
            )
        }
        if (this.state.specificFormOpen === true) {
            specificAddForm = (
                <div style={{padding: '0px'}}>
                    <GridCell span = "12">
                         <TextField fullwidth label ="Enter the tag"  autoComplete="off"  name="name" value = {this.state.addData.tagOfSection} onChange = {this.handleTagChange} style={{ height: '140%' }}/>
                    </GridCell>
                    <br />
                    <GridCell span = "12">
                        <Reactsel
                                name="taxonomylist"
                                onChange={this.handleTaxonomyParentChange}
                                value={this.state.addedTaxonomyParent}
                                options={this.state.data.taxonomyComboDropDown}
                                placeholder="--Select Taxonomy Parent--"
                                isMulti>
                        </Reactsel>
                    </GridCell>
                    <br />
                    {aspectAddForm}
                </div>
            )
        }

        if (this.state.formOpen === true) {
            generalAddForm = (
                <GridCell span = "10" style={{padding: '0px'}}>
                    <TextField fullwidth label = "Enter the name"   autoComplete="off"  name="name" value = {this.state.addData.nameOfSection} onChange = {this.handleNameChange} style={{ height: '140%' }}/>
                    <TextField fullwidth label = "Image Link"       autoComplete="off"  name="name" value = {this.state.addData.imgLinkSection} onChange = {this.handleImageLinkChange} style={{height: '140%'}}/> 
                    <TextField fullwidth label = "Listing Sequence" autoComplete="off"  name="name" type = "number" value = {this.state.addData.listingSequenceSection} onChange = {this.handleListingSequenceChange} style={{height: '140%'}}/>
                    {activeComponent}
                    <br/>
                    <GridCell span = "12">
                        <Typography use="headline7">Description:</Typography>
                        <div className = 'mdc-layout-grid__cell mdc-layout'
                                style={{height: '200px', overflow: 'auto'}}>
                        <GridCell span="12">
                            <Editor
                                editorState={this.state.editorData.editorStateRead}
                                wrapperClassName="demo-wrapper"
                                editorClassName="demo-editor"
                                onEditorStateChange={this.handleEditorDescriptionUpdate}
                                toolbar={{
                                    options:['inline', 'list' ],
                                    link: { inDropdown: true },
                                    inline:
                                        {
                                            options:['bold', 'italic', 'underline']
                                        },
                                }}
                            />
                        </GridCell>
                        </div>
                    </GridCell>
                    <br/>
                    {specificAddForm}
                    <br/>
                    <span><Button raised style={{ width: '50%' }} onClick={((e) => handleSaveTaxonomy(e))}>Save</Button>
                    <Button style={{ width: '50%' }} onClick={((e) => handleFormClose(e))}>Cancel</Button></span>
                    <br />
                    <StatusMessage error_msg = {this.state.errorMessage} />
                </GridCell>
            )
        }

        return (
            <div>
                <Grid className="opportunity-list-item">
                    <GridCell span = "12">
                        <Card style={{padding: '0px'}}>
                            <Grid>
                                <GridCell span = "11">
                                    <Typography use="headline5">{this.props.match.params.typeName}</Typography>
                                </GridCell>
                                <GridCell span = "1">
                                    <Button raised style={{ width: '100%' }} onClick={((e) => handleBackAction(e))}>Back</Button>
                                </GridCell>
                            </Grid>
                        </Card>
                    </GridCell>
                    <GridCell span = "7">
                        <button className="mdc-button" align = "left" aria-label="Favorite" onClick = {((e) => handleFormOpen(e))}>
                            Add a {this.props.match.params.typeName}
                        </button>
                        {generalAddForm}
                    </GridCell>
                    <GridCell span = "12">
                    </GridCell>
                    <GridCell span = "12">
                        {fetchForm}
                    </GridCell>
                </Grid>
                {individualTaxonomy}
            </div>
        )
    } 
}

function mapStateToProps({user, admin}) {
  return {
    user,
    admin
  }
}

function mapDispatchToProps() {
  return {}
}

export default connect(mapStateToProps, mapDispatchToProps)(TaxonomyConfiguration);


// WEBPACK FOOTER //
// ./src/views/learning_resource_admin/TaxonomyConfiguration.jsx